import React from 'react'
import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

import { TradeHoldersChart } from './trade-holders-chart'

import type { TradeHoldersChartTooltipProps } from './trade-holders-chart-tooltip'

type TradeHolderChartsItemProps = {
  title: string
  count: React.ReactNode
  points: Array<{ x: number; y: number }>
  type: 'number' | 'percentage'
  tooltipElement?: React.ReactElement<TradeHoldersChartTooltipProps>
}

export function TradeHoldersChartsItem(props: TradeHolderChartsItemProps) {
  return (
    <Root>
      <Info>
        <Title>{props.title}</Title>
        <Count>{props.count}</Count>
      </Info>
      <Chart>
        <TradeHoldersChart
          data={props.points}
          type={props.type}
          tooltipElement={props.tooltipElement}
        />
      </Chart>
    </Root>
  )
}

const Root = styled.div`
  padding: 10px 15px;
  display: grid;
  grid-template-columns: auto minmax(140px, 1fr);
  gap: 6px;

  border-radius: 10px;
  border: 1px solid var(--background-2);
  background: var(--background-3);
  min-height: 80px;
`
const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`
const Title = styled.div`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
`
const Count = styled.div`
  color: var(--text-12);
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
`

const Chart = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
`

const Skeleton_ = () => {
  return (
    <Root>
      <Info>
        <Title>
          <Skeleton.Line width={'7ch'} />
        </Title>
        <Count>
          <Skeleton.Line uppercase width={'3ch'} />
        </Count>
      </Info>
      <Chart>
        <Skeleton variant="rectangle" height={'100%'} width={'100%'} />
      </Chart>
    </Root>
  )
}

TradeHoldersChartsItem.Skeleton = Skeleton_
